import "../index.css";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  IconButton,
  LabelValue,
  Row,
  Tooltip,
  Typography,
} from "@/ui-kit";
import { PencilIcon } from "lucide-react";
import { ImageGallery } from "@/components/ImageGallery";
import { FormattedDate } from "@/components/columns/FormattedDate";
import type { IInspectorLicense } from "@/types/users-inspectors";

type IProps = {
  license: IInspectorLicense;
  onEdit?: () => void;
};

export const LicenseDetailsCard = ({ license, onEdit }: IProps) => {
  const { t } = useTranslation();
  const labelWidth = "128px";

  return (
    <Card className="profile-card" variant="layer1">
      <CardContent>
        <Row gap={24} alignmentVertical="top">
          <div className="profile-card__image-gallery">
            <ImageGallery
              imageUrls={[license.frontImageUrl, license.backImageUrl]}
            />
          </div>
          <div className="profile-card__details">
            <Row gap={12}>
              <Typography
                as="h3"
                weight="bold"
                variant="h3"
                color="text-primary"
                text={t("label.drivers_license")}
              />

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="layer2"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__sections">
              <div className="profile-card__section">
                <LabelValue
                  label={t("label.license_number")}
                  value={license.documentNumber}
                  labelWidth={labelWidth}
                  canCopy
                />
                <LabelValue
                  label={t("label.issuance_date")}
                  value={<FormattedDate value={license.issuanceDate} />}
                  labelWidth={labelWidth}
                />
                <LabelValue
                  label={t("label.expiry_date")}
                  value={<FormattedDate value={license.expiryDate} />}
                  labelWidth={labelWidth}
                />
              </div>
            </div>
          </div>
        </Row>
      </CardContent>
    </Card>
  );
};
